import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { BaseComponent, HelperService, UserService } from "@mypxplat/xplat/core";
import { WebCommunityService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-community-post-detail",
  templateUrl: "community-post-detail.component.html",
})
export class CommunityPostDetailComponent extends BaseComponent {
  public postId: string;
  public post: any;
  public replies: any[];
  public postNotFound: boolean;
  public postDetailRepliesSubscription: any;
  constructor(userService: UserService, public activatedRoute: ActivatedRoute, public communityService: WebCommunityService, public helperService: HelperService) {
    super(userService);
  }

  ngOnInit() {
    this.postId = this.activatedRoute.snapshot.params["id"];
    if (this.postId) {
      this.getPost();
    }
  }

  getPost() {
    this.communityService
      .getPostByID(this.postId)
      .then((result: any) => {
        let parentPostID = this.postId;
        if (result[0] && result[0].parentID) {
          parentPostID = result[0].parentID;
          this.communityService
            .getPostByID(parentPostID)
            .then((result: any) => {
              this.post = result[0];
              this.replies = result.filter((item) => item.parentID);
            })
            .catch((err) => {});
        } else {
          this.post = result[0];
          this.replies = result.filter((item) => item.parentID);
        }
        this.postDetailRepliesSubscription = this.communityService.watchPostReplies(parentPostID).subscribe((result) => {
          this.replies = result;
        });
      })
      .catch((err) => {
        this.postNotFound = true;
      });
  }
}
